import { render, staticRenderFns } from "./modifyCollectePop.vue?vue&type=template&id=006f0e11&scoped=true"
import script from "./modifyCollectePop.vue?vue&type=script&lang=js"
export * from "./modifyCollectePop.vue?vue&type=script&lang=js"
import style0 from "./modifyCollectePop.vue?vue&type=style&index=0&id=006f0e11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006f0e11",
  null
  
)

export default component.exports